import { consumeAuthErrorParam } from "@bindery/auth-consumer/browser";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./index.css";

// Read and stripped once, before the first render, so StrictMode's double
// render cannot consume it and then render without it.
const authError = consumeAuthErrorParam();

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("index.html lost its #root");
createRoot(rootElement).render(
  <StrictMode>
    <App authError={authError} />
  </StrictMode>,
);
